<nav class="nsw-side-nav mobile-side-nav-menu" role="navigation" aria-label="waterMonitoringMenu">
	<div class="has-children nsw-side-nav__header--fullwidth" role="navigation" >		
		<a routerLink="/waterMonitoring" >Water monitoring</a>
		<button class="side-nav__toggle reset--button" 
			aria-label="Water Monitoring" [attr.aria-expanded]="mobileMenuExpanded" aria-controls="secondaryNavMobile0"
			(click)="onExpandMobileMenuClicked($event)">
			<span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">keyboard_arrow_down</span>
		</button>
	</div>
  	<ul class="nav-list" *ngIf="mobileMenuExpanded" role="tree" id="secondaryNavMobile0" [attr.aria-hidden]="!mobileMenuExpanded">
		<li routerLinkActive="active-item" role="none">
			<a routerLink="/waterMonitoring/howWeMonitor" role="treeitem">How we monitor</a>
		</li>
		<li routerLinkActive="active-item" role="none">
			<a routerLink="/waterMonitoring/howWeReport" role="treeitem">How we report</a>
		</li>
		<li routerLinkActive="active-item" role="none" >
			<a routerLink="/waterMonitoring/waterQualityData" role="treeitem">Water quality data</a>
		</li>
		<li routerLinkActive="active-item" role="none">
			<a routerLink="/waterMonitoring/beachwatchDataFeeds" role="treeitem">Beachwatch data feeds</a>
		</li>
	</ul>
</nav>


<app-bread-crumb 
	[Locations]="[{ target : 'home', label : 'Home' }, { target : '/waterMonitoring', label : 'Water monitoring' }]"
	[current]="currentRoute">
</app-bread-crumb>       

<div class="nsw-container">
	<div class="nsw-layout">	
		<div class="nsw-layout__sidebar nsw-layout__sidebar--desktop">
			<nav class="nsw-side-nav desktop-side-nav-menu" aria-label="waterMonitoringMenu">
				<div class="nsw-side-nav__header">
					<a routerLink="/waterMonitoring" id="waterMonitoringMenu">Water monitoring</a>
				</div>
				<ul>
					<li routerLinkActive="active-item">
						<a routerLink="/waterMonitoring/howWeMonitor">How we monitor</a>
					</li>
					<li routerLinkActive="active-item">
						<a routerLink="/waterMonitoring/howWeReport">How we report</a>
					</li>
					<li routerLinkActive="active-item">
						<a routerLink="/waterMonitoring/waterQualityData">Water quality data</a>
					</li>
					<li routerLinkActive="active-item">
						<a routerLink="/waterMonitoring/beachwatchDataFeeds">Beachwatch data feeds</a>
					</li>
				</ul>
			</nav>
		</div>		

		<main class="nsw-layout__main">
			<router-outlet></router-outlet>	
		</main>

	</div>

</div>

